import { useTheme } from "@mui/material";
import { ConfirmOptions, useConfirm } from "material-ui-confirm";

const useDestructiveConfirm = () => {
  const confirm = useConfirm();
  const theme = useTheme();

  function destructiveConfirm(options?: ConfirmOptions) {
    return confirm({
      ...options,
      dialogActionsProps: {
        sx: {
          justifyContent: "space-between",
        },
      },
      titleProps: {
        sx: {
          color: theme.palette.error.main,
        },
      },
      confirmationButtonProps: {
        color: "error",
      },
    });
  }

  return destructiveConfirm;
};

export { useDestructiveConfirm };
